module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.title")))]), _vm._v(" "), _c('img', {
    staticClass: "main-phone",
    style: ({
      marginTop: -500 - _vm.phoneOffset + 'px',
      marginBottom: _vm.phoneOffset + 'px'
    }),
    attrs: {
      "src": require("../assets/phone.png")
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "content column"
  }, [_c('md-whiteframe', {
    staticClass: "md-padding col-sm-8 col-sm-offset-2",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "intro col-sm-8 col-sm-offset-2"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("home.intro")) + "\n\t\t\t\t")])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.features")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.features), function(feature) {
    return _c('div', {
      staticClass: "feature col-md-4"
    }, [_c('i', {
      staticClass: "fa",
      class: feature.icon,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t(feature.title)))]), _vm._v(" "), (feature.extra) ? _c('div', {
      staticClass: "extra"
    }, [_c('span', [_vm._v("Extra funkció")])]) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t(feature.desc)) + "\n\t\t\t\t")])
  }))]), _vm._v(" "), _c('md-whiteframe', {
    staticClass: "references md-padding col-sm-8 col-sm-offset-2",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("home.references")))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("home.referencesDesc")) + "\n\n\t\t\t\t"), _c('div', {
    staticClass: "row apps"
  }, [_c('span', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/startup-safary/id1225499566?mt=8",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-apple",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" iOS"), _c('br')])]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.conflive.safary",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-android",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Android"), _c('br')])])])]), _vm._v(" "), _c('carousel-3d', {
    attrs: {
      "width": 294,
      "height": 522,
      "autoplay": true,
      "autoplay-timeout": 2000
    }
  }, [_c('slide', {
    attrs: {
      "index": 0
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ex1.jpg")
    }
  })]), _vm._v(" "), _c('slide', {
    attrs: {
      "index": 1
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ex2.jpg")
    }
  })]), _vm._v(" "), _c('slide', {
    attrs: {
      "index": 2
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ex3.jpg")
    }
  })]), _vm._v(" "), _c('slide', {
    attrs: {
      "index": 3
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ex4.jpg")
    }
  })]), _vm._v(" "), _c('slide', {
    attrs: {
      "index": 4
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ex5.jpg")
    }
  })]), _vm._v(" "), _c('slide', {
    attrs: {
      "index": 5
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/ex6.jpg")
    }
  })])], 1)], 1), _vm._v(" "), _c('md-whiteframe', {
    staticClass: "contact md-padding col-sm-8 col-sm-offset-2",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("home.contact")))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("home.contactDesc"))), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@conflive.com"
    }
  }, [_vm._v("info@conflive.com")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "nav"
  }, [_c('a', {
    attrs: {
      "href": "http://conflive.com",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72c085d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 29
// module chunks = 1